<!-- Prototype: #action-dialog → requestForm() / requestStatus(). Texts kept, demo notes dropped. -->
<div class="request-dialog" role="document">
  <button class="request-dialog__close" type="button" aria-label="Close" (click)="close()">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>
  </button>

  <ng-container *ngIf="!sent; else sentState">
    <p class="request-dialog__eyebrow">New-reference request</p>
    <h2 class="request-dialog__title" id="reference-request-title">What are you creating?</h2>

    <form class="request-dialog__form" (submit)="onSubmit($event)">
      <label class="request-dialog__field">
        <span class="request-dialog__label">Your brief</span>
        <textarea
          name="brief"
          rows="4"
          required
          [maxlength]="maxLength"
          [placeholder]="placeholder"
          [disabled]="step === 'sending'"
          [(ngModel)]="brief"
          cdkFocusInitial></textarea>
      </label>

      <p class="request-dialog__note">We review your brief and capacity before accepting it. Scope and timing are confirmed at acceptance.</p>
      <p class="request-dialog__error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

      <button class="request-dialog__submit" type="submit" [disabled]="!canSubmit">{{ submitLabel }}</button>
    </form>

    <p class="request-dialog__footnote">
      <ng-container *ngIf="isSignedIn; else guestNote">We’ll reply to {{ replyEmail }}.</ng-container>
      <ng-template #guestNote>Sign in so we can reply to you. Your brief stays here while you do.</ng-template>
    </p>
  </ng-container>

  <ng-template #sentState>
    <p class="request-dialog__eyebrow">New-reference request</p>
    <h2 class="request-dialog__title" id="reference-request-title">Request received.</h2>
    <blockquote class="request-dialog__brief">{{ brief }}</blockquote>
    <div class="request-dialog__status">
      <strong>Awaiting acceptance</strong>
      <p>Your brief is waiting for a scope and capacity review. We’ll confirm the timing by email to {{ replyEmail }}.</p>
    </div>
    <button class="request-dialog__submit" type="button" (click)="close()">Done</button>
  </ng-template>
</div>
